import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "umbraco-form-fieldset-column umbraco-forms-container" }

import { PropType } from "vue";
import { IUmbracoFormColumn } from "@/models/umbraco-forms/IUmbracoFormColumn";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormFieldsetColumn',
  props: {
  column: {
    type: Object as PropType<IUmbracoFormColumn>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { column: __props.column })
  ]))
}
}

})